import { createAction, props } from '@ngrx/store';
import { Design } from '../../interfaces/design';

export const loadDesign = createAction('[Design/API] Load Design');

export const loadDesignSuccess = createAction('[Design/API] Load Design Success', props<{ design: Design }>());

export const loadDesignFailure = createAction('[Design/API] Load Design Failure', props<{ error: any }>());

export const updateDesign = createAction('[Design/API] Update Design', props<{ design: Design }>());

export const updateDesignSuccess = createAction('[Design/API] Update Design Success', props<{ design: Design }>());

export const updateDesignFailure = createAction('[Design/API] Update Design Failure', props<{ error: any }>());

export const clearDesign = createAction('[Design/API] Clear Design');
